import React, { createContext, ReactNode, useEffect, useRef, useState } from 'react';

type SetStateDispatch<T> = React.Dispatch<React.SetStateAction<T>>;

export enum HeaderPopovers {
  ACTIVITY,
  PROFILE,
  LIVEGIRLS,
  SEO_CATEGORIES,
  MOREGIRLS,
}

export enum ActiveNestedItem {
  SITEPICKER,
  MOREGIRLS,
  LIVEGIRLS,
  SEO_CATEGORIES,
}

export type ActiveNestedMobileItem = ActiveNestedItem | string;

type HeaderContext = {
  activeNestedMobileMenu: ActiveNestedMobileItem | null;
  activePopover: HeaderPopovers | null;
  closeMobileMenu: () => void;
  mobileMenuOpened: boolean;
  popoverContentLoaded: boolean;
  setActiveNestedMobileMenu: SetStateDispatch<ActiveNestedMobileItem | null>;
  setActivePopover: SetStateDispatch<HeaderPopovers | null>;
  setMobileMenuOpened: SetStateDispatch<boolean>;
  setPopoverContentLoaded: SetStateDispatch<boolean>;
};

type Props = {
  children?: ReactNode;
};

export const HeaderContext = createContext<HeaderContext>({} as HeaderContext);

export const HeaderProvider = (props: Props) => {
  const [activePopover, setActivePopover] = useState<HeaderPopovers | null>(null);
  const [activeNestedMobileMenu, setActiveNestedMobileMenu] = useState<ActiveNestedMobileItem | null>(null);
  const [mobileMenuOpened, setMobileMenuOpened] = useState(false);
  const [popoverContentLoaded, setPopoverContentLoaded] = useState<boolean>(false);
  const previousBodyOverflowRef = useRef<string | null>(null);

  const closeMobileMenu = () => {
    setActiveNestedMobileMenu(null);
    setMobileMenuOpened(false);
  };

  useEffect(() => {
    if (!activePopover) {
      setPopoverContentLoaded(false);
    }
  }, [activePopover]);

  useEffect(() => {
    if (mobileMenuOpened) {
      if (previousBodyOverflowRef.current === null) {
        previousBodyOverflowRef.current = document.body.style.overflow;
      }

      document.body.style.overflow = 'hidden';
      return;
    }

    if (previousBodyOverflowRef.current !== null) {
      document.body.style.overflow = previousBodyOverflowRef.current;
      previousBodyOverflowRef.current = null;
    }
  }, [mobileMenuOpened]);

  useEffect(() => {
    return () => {
      if (previousBodyOverflowRef.current !== null) {
        document.body.style.overflow = previousBodyOverflowRef.current;
        previousBodyOverflowRef.current = null;
      }
    };
  }, []);

  return (
    <HeaderContext.Provider
      value={{
        activeNestedMobileMenu,
        activePopover,
        closeMobileMenu,
        mobileMenuOpened,
        popoverContentLoaded,
        setActiveNestedMobileMenu,
        setActivePopover,
        setMobileMenuOpened,
        setPopoverContentLoaded,
      }}
    >
      {props.children}
    </HeaderContext.Provider>
  );
};
